
import axios from 'axios';
import map from 'lodash/map';
import mapKeys from 'lodash/mapKeys';
import assign from 'lodash/assign';
import { addValidationRule } from 'formsy-react';

export const getErrorMessage = (error, defaultErrorMessage) => {
  return error && (error.description || error.message || defaultErrorMessage) || defaultErrorMessage
};

/**
 * getValidations
 * Decorator for matchRegExp
 * @param { validations } object
 */
export const getValidations = (validations) => {
  if (validations && validations.matchRegexp) {
    validations.matchRegexp = RegExp(validations.matchRegexp);
  }
  return validations;
};

/**
 * submitForm
 * Public method to submit form using axios
 * @param { url } string The URL to post to
 * @param { formData } object Form data object to post
 */
export const submitForm = (url, formData) => {
  return axios.post(url, formData);
};

/**
 * _getFormFieldValue
 * Private method to get value of a field in the given form or another form using redux store
 * @param { field } string Identifier of the form field. i.e - "parentAge", "otherForm.parentAge"
 * @param { values } object Field values in the given form
 * @param { store } object Redux store
 */
const _getFormFieldValue = (field, values, store) => {
  // Let's find the field value in the given form
  if (values[field]) {
    return values[field];
  }

  // Let's find in the redux store
  const state = store.getState();
  const formDataCollection = map(state.forms, (form, formKey) => {
    return mapKeys(form.formData, (_, fieldKey) => formKey + '.' + fieldKey);
  });
  const mergedFormData = assign({}, ...formDataCollection);
  if (mergedFormData[field]) {
    return mergedFormData[field];
  }

  return undefined;
};

/**
 * addCustomValidationRules
 * Add custom validation rules to Formsy
 * @param { store } object Redux store
 */
export const addCustomValidationRules = (store) => {
  // isGreaterThan validation rule
  addValidationRule('isGreaterThan', (values, value, otherField) => {
    return Number(value) > Number(_getFormFieldValue(otherField, values, store));
  });

  // isLessThan validation rule
  addValidationRule('isLessThan', (values, value, otherField) => {
    return Number(value) < Number(_getFormFieldValue(otherField, values, store));
  });

  // isDateAfter validation rule
  addValidationRule('isDateAfter', (values, value, otherField) => {
    return Number(value) > Number(_getFormFieldValue(otherField, values, store));
  });

  // isDateAfter validation rule
  addValidationRule('isDateBefore', (values, value, otherField) => {
    return Number(value) < Number(_getFormFieldValue(otherField, values, store));
  });

  // TODO: Add more validation rules here...
};



// WEBPACK FOOTER //
// ./src/utilities/form-utility.js